import axios from 'axios';
import {ua, qs} from "./browser";
// import {stringify as qsStringify} from 'qs';

// stringify方法，对象转字符串
let qsStringify = (obj) => {
    let ret = "";
    for (let key in obj) {
        const enKey = encodeURIComponent(key);
        const enValue = encodeURIComponent(obj[key]);
        ret += `${enKey}=${enValue}&`;
    }
    return ret;
}

let baseUrl = '/';

function getUrl(url, yapimockurl) {
    if (url.indexOf('http') > -1) {
        return url;
    } else {
        return /mock=true/.test(location.href) && yapimockurl ? yapimockurl : (url.charAt(0) == '/' ? '' : baseUrl) + url;
    }
}
function getHeaders(headers={}) {
    headers = headers.constructor === Object ? headers : {};
    let sysinfo = window.__gvalkkmh && window.__gvalkkmh.sys;
    if (sysinfo && sysinfo.device_id) {
        headers = Object.assign({
            "X-Device": sysinfo.device_id,
            "Muid": sysinfo.muid, //android
            "App-Info": sysinfo.app_info,
            "Package-Id": sysinfo.package_id, //包名
        }, headers);
    }
    let user_agent_mini = decodeURIComponent(qs["useragent"] ? qs["useragent"] : "");
    headers = { ...headers, ...{ "User-Agent-Mini": user_agent_mini } }
    return headers;
}
/**
 * ** Get(Post) 请求封装
 * @ url 请求地址
 * @ data 发送的数据
 * @ sources 用于停止当前请求
 * @ timeout 请求超时时间
 * @ apiUrl 修改默认 baseUrl
 * */
const Get = function ({ url = '', data = {}, sources = [], timeout = 1000 * 10, headers = {}, yapimockurl = '' } = {}) {

    //配置请求地址
    url = getUrl(url, yapimockurl);
    sources = Array.isArray(sources) ? sources : []; //存储请求信息,用于停止请求
    let CancelToken = axios.CancelToken; //停止请求使用
    let token = new CancelToken(function executor(cancel) {
        sources.push(cancel);
    });
    data = data ? data : {};
    data.success = 1;
    return axios.get(
        url,
        {
            params: data,
            cancelToken: token, //停止请求使用
            timeout: timeout, //请求超时设置
            headers: getHeaders(headers),
        }
    );
};

const Post = function ({ url = '', data = {}, sources = [], timeout = 1000 * 10, headers = {}, yapimockurl = '' } = {}) {

    //配置请求地址
    url = getUrl(url, yapimockurl);

    sources = Array.isArray(sources) ? sources : []; //存储请求信息,用于停止请求
    let CancelToken = axios.CancelToken;//停止请求使用
    let token = new CancelToken(function executor(cancel) {
        sources.push(cancel);
    });

    data = data ? data : {};
    headers = headers || {}
    let isApplicationJson = JSON.stringify(headers).toLocaleLowerCase().indexOf("application/json") > -1;
    data = isApplicationJson ? data : qsStringify(data)
    return axios.post(
        url,
        data,
        {
            cancelToken: token, //停止请求使用
            timeout: timeout,//请求超时设置
            headers: getHeaders(headers),
        }
    );
};

const Delete = function ({ url = '', data = {}, sources = [], timeout = 1000 * 10, headers = {}, yapimockurl = '' } = {}) {

    //配置请求地址
    url = getUrl(url, yapimockurl);
    sources = Array.isArray(sources) ? sources : []; //存储请求信息,用于停止请求
    let CancelToken = axios.CancelToken; //停止请求使用
    let token = new CancelToken(function executor(cancel) {
        sources.push(cancel);
    });
    data = data ? data : {};
    data.success = 1;
    return axios.delete(
        url,
        {
            params: data,
            cancelToken: token, //停止请求使用
            timeout: timeout, //请求超时设置
            headers: getHeaders(headers),
        }
    );
};

const $Http = axios;

export {
    Get,
    Post,
    Delete,
    $Http,
}

